import React, { useEffect } from 'react'
import { pageTitle } from '../../helper'
import Card from '../Card'
import Cta from '../Cta'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ServicesPage() {
  pageTitle('Service');
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <PageHeading 
        title='Services'
        bgSrc='images/service_hero_bg.jpeg'
        pageLinkText='Services'
      />
      <Spacing lg='150' md='80'/>
      <Div className='cs-shape_wrap_4'>
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">
          <SectionHeading
            title='We Are Experts In These Services' 
            subtitle='End-to-End Software Development & System Integration'
            variant='cs-style1 text-center'
          />
          <Spacing lg='90' md='45'/>
          <Div className='row'>
            <Div className='col-lg-3 col-sm-6 cs-hidden_mobile'></Div>
            <Div className='col-lg-3 col-sm-6'>
              <Card
                title='Web Solutions'
                link='/service/web-solutions'
                src='/images/service_1.jpeg'
                alt='Service'
              />
              <Spacing lg='0' md='30'/>
            </Div>
            <Div className='col-lg-3 col-sm-6 cs-hidden_mobile'></Div>
            <Div className='col-lg-3 col-sm-6'>
              <Card
                title='Mobile Solutions'
                link='/service/mobile-solutions'
                src='/images/service_2.jpeg'
                alt='Service'
              />
              <Spacing lg='0' md='30'/>
            </Div>
            <Div className='col-lg-3 col-sm-6'>
              <Card
                title='Enterprise Solutions'
                link='/service/enterprise-solutions'
                src='/images/service_3.jpeg'
                alt='Service'
              />
              <Spacing lg='0' md='30'/>
            </Div>
            <Div className='col-lg-3 col-sm-6 cs-hidden_mobile'></Div>
            <Div className='col-lg-3 col-sm-6'>
              <Card
                title='App Development & Processing'
                link='/service/app-development'
                src='/images/service_4.jpeg'
                alt='Service'
              />
              <Spacing lg='0' md='30'/>
            </Div>
            <Div className='col-lg-3 col-sm-6 cs-hidden_mobile'></Div>
            <Div className='col-lg-3 col-sm-6 cs-hidden_mobile'></Div>
            <Div className='col-lg-3 col-sm-6'>
              <Card
                title='Billing & Payment Integrations'
                link='/service/billing-payments'
                src='/images/service_5.jpeg'
                alt='Service'
              />
              <Spacing lg='0' md='30'/>
            </Div>
            <Div className='col-lg-3 col-sm-6 cs-hidden_mobile'></Div>
            <Div className='col-lg-3 col-sm-6'>
              <Card
                title='Other IT Solutions'
                link='/service/other-it-solutions'
                src='/images/service_6.jpeg'
                alt='Service'
              />
              <Spacing lg='0' md='30'/>
            </Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg='150' md='80'/>
      <Div className="container">
        <SectionHeading
          title='How We Work' 
          subtitle='Our Process'
          variant='cs-style1 text-center'
        />
        <Spacing lg='85' md='40'/>
        <Div className="row">
          {[
            { step: '01', title: 'Discovery & Analysis', desc: 'Understanding business goals and technical requirements' },
            { step: '02', title: 'Architecture & Design', desc: 'Defining scalable and integration-ready solutions' },
            { step: '03', title: 'Development', desc: 'Clean, secure, and maintainable implementation' },
            { step: '04', title: 'Testing & Deployment', desc: 'Quality assurance and production release' },
            { step: '05', title: 'Support & Growth', desc: 'Ongoing maintenance and system improvements' },
          ].map((item, index) => (
            <Div className="col-lg col-sm-6" key={index}>
              <Div className="cs-iconbox cs-style1 text-center" style={{padding: '30px 20px'}}>
                <h3 className="cs-accent_color" style={{fontSize: '40px', marginBottom: '15px'}}>{item.step}</h3>
                <h2 className="cs-iconbox_title" style={{fontSize: '20px', marginBottom: '10px'}}>{item.title}</h2>
                <Div className="cs-iconbox_subtitle">{item.desc}</Div>
              </Div>
              <Spacing lg='30' md='30'/>
            </Div>
          ))}
        </Div>
      </Div>
      <Spacing lg='125' md='55'/>
      <TestimonialSlider/>
      <Spacing lg='150' md='80'/>
      <Div className="container">
        <Cta 
          title={"Have a project in mind? <br />Let's <i>build</i> it together"}
          btnText='Get In Touch' 
          btnLink='/contact' 
          bgSrc='/images/cta_bg.jpeg'
        />
      </Div>
    </>
  )
}
